module.exports = __webpack_public_path__ + "static/img/charm_level_88.0071477.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/charm_level_88.png
// module id = H4cZ
// module chunks = 0